<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab *ngFor="let land of bundeslandFilterService?.getSelectedBundesLaenderNamen()" [label]="land">
    <ng-container *ngIf="isAvailableForBundesland()">
      <app-rbb-wintersport-wetter-texte></app-rbb-wintersport-wetter-texte>
      <app-rbb-wintersport-wetter-werte></app-rbb-wintersport-wetter-werte>
    </ng-container>
  </mat-tab>
</mat-tab-group>

<div class="wetter_content_container" *ngIf="!isAvailableForBundesland()">
  <h2>Es liegt kein Wintersportwetter für {{selectedBundesland}} vor</h2>
</div>
